import React, { FC } from 'react';
import { MTools } from '@/components';
import { Title } from '../index';
import styles from './index.less';
import meetingIcon from '@/assets/image/meetingIcon.png';
import listIcon from '@/assets/image/listIcon.png';

interface ComProps {

}

const Exposition: FC<ComProps> = ({

}) => {
  const handleGoToCompanyList = () => {
    MTools.Url.gotoUrl('/app/company');
  }

  const gotuurl = () => {
    window.open('https://720yun.com/vr/d712cxOgq4w')
  }

  return (
    <div className={styles.comWrapper}>
      <Title type={2} />
      <div className={styles.meetingEntry}>
        <div className={styles.entryItem}>
          <div className={styles.entryIcon}>
            <img src={meetingIcon} alt="" />
          </div>
          <div className={styles.entryText} onClick={gotuurl}>进入展会</div>
        </div>
        <div className={styles.entryItem} onClick={handleGoToCompanyList}>
          <div className={styles.entryIcon}>
            <img src={listIcon} alt="" />
          </div>
          <div className={styles.entryText}>企业列表</div>
        </div>
      </div>
      <div className={styles.meetingImg} onClick={gotuurl}>
        <img src="https://s.newscdn.cn/file/2022/09/2f1b86b3-85c9-4d49-adc6-a8cfdc7aa268.jpg" alt="" />
      </div>
    </div>
  );
};

export default Exposition;
